import { render } from "./NftStats.vue?vue&type=template&id=8416122e"
import script from "./NftStats.vue?vue&type=script&lang=js"
export * from "./NftStats.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__